import { Box, styled } from "@mui/material";

export const ResizeHandle = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$isDragging",
})<{ $isDragging: boolean }>(({ theme, $isDragging }) => ({
  position: "absolute",
  top: 0,
  right: -6, // Wider interactive area (12px total: 6px on each side of border)
  width: 12, // Larger hit area for easier mouse interaction
  height: "100%",
  cursor: "col-resize",
  zIndex: 300,
  backgroundColor: "transparent",

  // Visual indicator - thin line in the center
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: 4,
    height: "100%",
    backgroundColor: $isDragging ? theme.palette.primary.main : "transparent",
    transition: $isDragging ? "none" : "background-color 0.2s ease-in-out",
  },

  "&:hover::after": {
    backgroundColor: theme.palette.primary.main,
  },
}));
